export default __webpack_public_path__ + "static/media/Sara.e9d9abec.png";